import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=54c27bd6&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&id=54c27bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c27bd6",
  null
  
)

export default component.exports